import React from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import api from "../lib/api";

export default function NotificationBell() {
    const [open, setOpen] = React.useState(false);
    const [data, setData] = React.useState({ items: [], unread_count: 0 });

    const load = React.useCallback(() => {
        api.get("/admin/notifications").then(r => setData(r.data || { items: [], unread_count: 0 })).catch(() => {});
    }, []);

    React.useEffect(() => {
        load();
        const t = setInterval(load, 30000);
        return () => clearInterval(t);
    }, [load]);

    const markRead = async (id) => { await api.post(`/admin/notifications/${id}/read`); load(); };
    const markAllRead = async () => { await api.post("/admin/notifications/read-all"); load(); };

    return (
        <div className="relative">
            <button onClick={() => { setOpen(!open); if (!open) load(); }} className="relative p-2 hover:bg-muted rounded-lg" data-testid="notification-bell">
                <Bell className="h-5 w-5" />
                {data.unread_count > 0 && <span className="absolute top-0.5 right-0.5 w-4 h-4 bg-destructive text-destructive-foreground text-[10px] rounded-full flex items-center justify-center font-bold">{data.unread_count > 9 ? "9+" : data.unread_count}</span>}
            </button>
            {open && (
                <>
                    <div className="fixed inset-0 z-30" onClick={() => setOpen(false)}></div>
                    <div className="absolute right-0 mt-2 w-80 max-h-96 overflow-y-auto bg-card border border-border rounded-xl shadow-xl z-40" data-testid="notif-dropdown">
                        <div className="p-3 border-b border-border flex items-center justify-between">
                            <div className="font-medium">Notificări</div>
                            {data.unread_count > 0 && <button onClick={markAllRead} className="text-xs text-primary hover:underline" data-testid="notif-mark-all">Marchează toate</button>}
                        </div>
                        {data.items.length === 0 && <p className="p-4 text-sm text-muted-foreground text-center">Nimic nou.</p>}
                        {data.items.map(n => (
                            <Link key={n.notif_id} to={n.link || "#"} onClick={() => { markRead(n.notif_id); setOpen(false); }}
                                  className={`block p-3 border-b border-border/40 hover:bg-muted ${n.is_read ? "opacity-60" : "bg-primary/5"}`} data-testid={`notif-${n.notif_id}`}>
                                <div className="font-medium text-sm">{n.title}</div>
                                <div className="text-xs text-muted-foreground">{n.body}</div>
                                <div className="text-[10px] text-muted-foreground mt-1">{new Date(n.created_at).toLocaleString("ro-RO")}</div>
                            </Link>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
